<div class="h100">
	<div class="page-title">년도별 생산/출하</div>

	<div class="mb10">
    <select class="yy" [(ngModel)]="search.selectYear" (change)="getYearProdSaleReport()">
      <option *ngFor="let item of yearList.slice().reverse()" value="{{item.value}}">{{item.title}}</option>
    </select>

		<div class="unit">(대,백만원)</div>
	</div>

	<div class="statistics">
    <ag-grid-angular
      #myGrid

      style="width: 100%;height:calc(100% - 0px);"
      class="ag-theme-balham"

      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="dataList"
      [pagination]="false"
      [overlayNoRowsTemplate]="noRowsTemplate"
      [rowSelection]="rowSelection"
      [frameworkComponents]="frameworkComponents"

      (gridReady)="onGridReady($event)"
    >
    </ag-grid-angular>
	</div>
</div>
